export default "__VITE_ASSET__D2qlx9DA__"